import { useMemo } from "react";
import Widget from "../../../../../components/baseWidget";
import { useWidgetContext } from "../../../../../helpers/hooks/useWidgetContext";
import { useMeasure } from "react-use";
import BaseChart from "../../../../../components/baseChart";
import { useAnalyticsGroupWidgetContext } from "../../../../../helpers/hooks/useAnalyticsGroupWidgetContext";
import styled from "styled-components";
import WidgetMarketingOverlay from "../../widgetMarketingOverlay";

const BarChart = ({ data, width, height }) => {
  const option = useMemo(() => {
    return {
      tooltip: {
        show: false,
      },
      legend: {
        show: true,
        formatter: "██████",
      },
      xAxis: {
        type: "category",
        data: ["Bob", "John", "Jane", "Jim", "Jill", "Jack"],
        axisLabel: {
          formatter: "██████",
        },
      },
      yAxis: [
        {
          name: "██████",
          type: "value",
          axisLabel: {
            formatter: "██████",
          },
        },
        {
          name: "██████",
          type: "value",
          axisLabel: {
            formatter: "██████",
          },
        },
      ],
      series: [
        {
          itemStyle: {
            color: "#58585E",
          },
          data: [10, 20, 30, 40, 50, 60],
          type: "bar",
        },
        {
          itemStyle: {
            color: "#3ECD89",
          },
          data: [234, 4354, 123, 4565, 323, 23],
          type: "line",
          yAxisIndex: 1,
        },
      ],
    };
  }, [data]);
  return <BaseChart height={height} width={width} options={option} />;
};

const TrendsWidgetSample = () => {
  const widget = useAnalyticsGroupWidgetContext();
  const [ref, { width, height }] = useMeasure();
  const title = widget?.widgetMeta?.title;

  return (
    <Wrapper ref={ref}>
      <div className="section-header">
        <div className="widget-title">{title}</div>
      </div>
      <div className="section-content">
        <WidgetMarketingOverlay
          height={height}
          width={width}
          marketingHtmlUrl={widget?.marketingHtmlUrl}>
          <div className="chart-container">
            <BarChart data={[]} width={width} height={height} />
          </div>
        </WidgetMarketingOverlay>
      </div>
    </Wrapper>
  );
};

export default TrendsWidgetSample;

const Wrapper = styled.div`
  border-radius: 20px;
  background-color: ${({ theme }) => theme.widget.background};
  filter: drop-shadow(5px 5px 10px rgba(0, 0, 0, 0.05));
  width: 100%;
  height: 100%;
  padding: 25px;
  .section-header {
    display: flex;
    .widget-title {
      flex: 1;
      text-decoration: underline;
    }
    .extended-report-option {
      box-sizing: border-box;
      height: 35px;
      width: 35px;
      cursor: pointer;
      position: relative;
      top: 7px;
      color: ${({ theme }) => theme.button_plain.text};
      border: 1.5px solid ${({ theme }) => theme.button_plain.border};
      &:hover {
        color: ${({ theme }) => theme.button_plain.hover_text};
        background: ${({ theme }) => theme.button_plain.hover};
      }
      border-radius: 8px;
      display: flex;
      justify-content: center;
      padding: 2px 8px;
      padding: 0px;
      align-items: center;
    }
    .ai-advisor-cta {
      position: relative;
      top: 7px;
    }
    .tabs-section {
      display: flex;
      justify-content: right;
      float: right;
      .tab {
        cursor: pointer;
        min-width: 80px;
        padding: 10px;
        margin: 5px;
        white-space: nowrap;
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        text-align: center;
        background: ${({ theme }) => theme.body};
        border-radius: 20px;
        color: ${({ theme }) => theme.text};
        &.selected {
          background: ${({ theme }) => theme.text};
          color: ${({ theme }) => theme.body};
        }
      }
    }
  }
`;
